import { Component, Host, Prop, h, Element, State } from '@stencil/core';

@Component({
  tag: 'cms-collapsible',
  styleUrl: 'cms-collapsible.scss',
  shadow: true,
})
export class CmsCollapsible {
  @State() isOpen = false;

  private hiddenTextHeight: number;

  /**
   * Set text Label to show more Content
   */
  @Prop() moreTextLabel: string;

  /**
   * Set accessible text for show more Content
   */
  @Prop() moreAccessibleName: string;
  /**
   * Set accessible text for show less Content
   */
  @Prop() lessAccessibleName: string;
  /**
   * Set text Label to show less Content
   */
  @Prop() lessTextLabel: string;

  /**
   * Set visible Text
   */
  @Prop() visibleText = '';

  /**
   * Set hidden text
   */
  @Prop() hiddenText = '';

  @Element() host: HTMLElement;

  private getNodeHeight(node: HTMLElement) {
    if (node !== undefined) {
      return node.offsetHeight + 16;
    }
  }

  private setState() {
    this.isOpen = !this.isOpen;
  }

  private showHiddenTextController() {
    this.setState();
  }

  componentDidLoad() {
    const hiddenContent = this.host.shadowRoot.querySelector('.hidden-content');
    this.hiddenTextHeight = this.getNodeHeight(hiddenContent as HTMLElement);
  }

  render() {
    return (
      <Host>
        <div class='cms-collapsible-inner'>
          <div class='visible-text' innerHTML={this.visibleText} />
          <div
            class='button-wrapper'
            style={{ display: this.hiddenText.length < 3 ? 'none' : null }}
          >
            {!this.isOpen ? (
              <cms-button
                onCmsButtonClick={() => this.showHiddenTextController()}
                theme='secondary'
                size='button-md'
                type='button'
                tagTitle={this.moreAccessibleName}
                label={this.moreTextLabel}
              />
            ) : (
              ''
            )}
          </div>
          <div
            class='hidden-text'
            style={{
              visibility: this.isOpen ? 'visible' : 'hidden',
              height: this.isOpen ? `${this.hiddenTextHeight}px` : '0px',
            }}
          >
            <div class='hidden-content' innerHTML={this.hiddenText} />
          </div>
          {this.isOpen ? (
            <cms-button
              onCmsButtonClick={() => this.showHiddenTextController()}
              theme='secondary'
              size='button-md'
              type='button'
              tagTitle={this.lessAccessibleName}
              label={this.lessTextLabel}
            />
          ) : (
            ''
          )}
        </div>
      </Host>
    );
  }
}
